/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Door from '@/components/Door'
import register from '@/components/register'
import tutorial from '@/components/tutorial'
import game from '@/components/game'
import categorylist from '@/components/categoryList'
import newslist from '@/components/newsList_.vue'
import beforeTutorial from '@/components/beforeTutorial'
import fiveWoneH from '@/components/5w1h'
import newspaper from '@/components/newspaper'
import factcheck from '@/components/factcheck'
import finalresult from '@/components/finalResult'
import printpaper from '@/components/printpaper'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Door',
      component: Door
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/beforetuto',
      name: 'beforetuto',
      component: beforeTutorial
    },
    {
      path: '/tutorial',
      name: 'tutorial',
      component: tutorial
    },
    {
      path: '/game/',
      component: game,
      children: [
        {
          path: 'news',
          name: 'newslist',
          component: newslist
        },
        {
          path: '',
          name: 'categorylist',
          component: categorylist
        },
        {
          path: '5w1h',
          name: '5w1h',
          component: fiveWoneH
        },
        {
          path: 'newspaper/:id',
          name: 'newspaper',
          component: newspaper
        },
        {
          path: 'factcheck',
          name: 'factcheck',
          component: factcheck
        }
      ]
    },
    {
      path: '/final',
      name: 'final',
      component: finalresult
    },
    {
      path: '/print',
      name: 'print',
      component: printpaper
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js